import React from 'react';
import { Button } from '@lightspeed/design-system-react';
import { useT, UT } from '@transifex/react';
import { withTranslations } from '../../tx';
import { VendImage } from '../vendImage/VendImage';
const refreshPage = () => window.location.reload();
const ErrorPageUnconnected = () => {
    const t = useT();
    return (React.createElement("section", { "data-testid": "error-page", className: "vd-error-main" },
        React.createElement("div", { className: "vd-flex vd-flex--column vd-flex--align-center vd-mt10" },
            React.createElement(VendImage, { relativeImagePath: "error/cannot-fetch-data-v3.svg" }),
            React.createElement("section", { className: "vd-section" },
                React.createElement("div", { className: "vd-section-wrap" },
                    React.createElement("h1", { className: "vd-header vd-header--section" }, t('Sorry, we couldn’t load this page.', { _context: 'Header' })),
                    React.createElement("p", { className: "vd-p" }, t('Please refresh this page and try again.')))),
            React.createElement(Button, { "data-track": "refresh-page", variant: "supplementary", onClick: refreshPage }, t('Refresh Page', { _context: 'Button' })),
            React.createElement("p", { className: "vd-flex vd-flex--align-center" },
                React.createElement(UT, { _inline: true, _str: `If this problem continues, check Lightspeed Retail’s <a href="https://status.vendhq.com" target="_blank" rel="noopener noreferrer" className="vd-link vd-link--secondary" >System Status</a> for real-time information about our system performance.` })))));
};
export const ErrorPage = withTranslations(ErrorPageUnconnected, 'ErrorPage');
